// extracted by mini-css-extract-plugin
module.exports = {"card":"_3NDtMnRPU4_6vwDwXjwHFn","picture":"_3-llRS3xHDb7puAQo2Vs2S","details":"_5gNVWa12t9RqJ6xTdC4UG"};